import { createBrowserRouter } from 'react-router-dom'

import { Layout } from 'ui/Layout/Layout'
import { LoginForm } from 'features/auth/LoginForm/LoginForm'
import { SignUpForm } from 'features/auth/SignUpForm/SignUpForm'
import { SoftwarePage } from 'features/software/SoftwarePage'
import { createPath } from 'utils/paths'
import { CategoryPage } from 'features/categories/CategoryPage'
import { AdminRoute } from 'features/admin/routes'
import { InstalledSoftwarePage } from 'features/installed-software/InstalledSoftwarePage'
import { IndexPage } from 'features/index/IndexPage'
import { analyticsTrackPathChange } from 'features/analytics/analytics'
import { SettingsPage } from 'features/settings/settings'
import { DownloadsPage } from 'features/downloads/DownloadsPage'
import { ApiTestPage } from 'features/api-test/ApiTestPage'

export const IndexRoutePath = createPath('/', <IndexPage />)
export const CategoryRoutePath = createPath('/category/:categoryId/', <CategoryPage />)
export const SoftwareRoutePathOld = createPath('/software/:softwareId/', <SoftwarePage />)
export const SoftwareRoutePath = createPath('/s/:categorySlug/:vendorSlug/:softwareSlug/:softwareId/', <SoftwarePage />)
export const InstalledSoftwareRoutePath = createPath('/installed/', <InstalledSoftwarePage />)
export const SettingsRoutePath = createPath('/settings/', <SettingsPage />)
export const DownloadsRoutePath = createPath('/downloads/', <DownloadsPage />)

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout showSidebar={true} />,
    children: [IndexRoutePath, CategoryRoutePath, SoftwareRoutePath, SoftwareRoutePathOld],
  },
  {
    path: '/',
    element: <Layout showSidebar={false} />,
    children: [InstalledSoftwareRoutePath, SettingsRoutePath, DownloadsRoutePath],
  },
  AdminRoute,
  {
    path: '/auth/',
    children: [
      { path: 'login/', element: <LoginForm /> },
      { path: 'signup/', element: <SignUpForm /> },
    ],
  },
  { path: '/error/', element: <TestError /> },
  { path: '/api-test/', element: <ApiTestPage /> },
])

router.subscribe((_state) => {
  analyticsTrackPathChange()
})

function TestError() {
  setTimeout(() => {
    throw new Error('Test error')
  }, 2000)
  return <div>Throwing error in 2 seconds... Check the console</div>
}
